import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {ToastService} from "../../../services/Toast.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {TemplatesService} from "../../../tpiq-services/templates.service";
import {Session} from "../../../services/Session";
import {FoundationInit} from "../../../directives/foundation.directive";
import {FormatAmountPipe} from "../../../pipes/format-amount.pipe";

declare const _: any;
declare const jQuery: any;

@Component({
  selector: 'app-template-info',
  standalone: true,
  imports: [CommonModule, FormsModule, FoundationInit, FormatAmountPipe],
  templateUrl: './template-info.component.html',
  styleUrl: './template-info.component.scss'
})
export class TemplateInfoComponent implements OnInit, OnDestroy {
  user: any;
  org: string;
  template: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  currentView = 'strategies';
  @Input() templateId: any;
  strategiesList: Array<any> = [];
  allAssociatedData: any = {};
  feesTableColumns: Array<any> = [
    {name: 'description', title: 'Description', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'associatedWithName', title: 'Associated With', type: 'normal', classes: 'pointer zero-overflow'}
  ];
  strategiesTableColumns: Array<any> = [
    {name: 'strategyName', title: 'Strategy', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'amount', title: 'Amount', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'associatedWithName', title: 'Associated With', type: 'normal', classes: 'pointer zero-overflow'},
    {name: 'recurring', title: 'Recurring', type: 'normal', classes: 'pointer zero-overflow'}
  ];
  associatedWithData: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'b870c7b6-802f-11eb-8aa0-1282986503dc', name: 'Non-deductible'}];

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private switchBoard: SwitchBoard,
    private templatesService: TemplatesService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.switchBoard.onToggleFeedback.next({
      display: false
    });
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.org = Session.getOrg();
    this.getStrategiesList();
  }

  getStrategiesList() {
    const obj: any = {
      fromIndex: -1
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user.id, obj, true)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.strategiesList = response.strategies;
        this.buildAssociatedObject();
        this.getTemplate();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To get strategies data');
      });
  }

  buildAssociatedObject(){
    const base = this;
    this.associatedWithData = [...this.associatedWithData];
    _.each(this.strategiesList, (obj) => {
      let strategyRates = [...base.associatedWithData];
      if (obj.customTaxRates){
        strategyRates = strategyRates.concat(obj.customTaxRates);
      }
      base.allAssociatedData[obj.id] = strategyRates;
    });
  }

  getTemplate(){
    this.loadingService.triggerLoadingEvent(true);
    this.templatesService.getTemplate(this.org, this.user.id, this.templateId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.template = response || {
        id: '',
        rates: [],
        fees: [],
        strategies: []
      };
      this.formatFeeLinesData();
      this.formatStrategiesData();
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to get template info');
    });
  }

  formatFeeLinesData() {
    const base = this;
    this.template.fees = this.template.fees || [];
    _.each(this.template.fees, (fee) => {
      const obj = _.find(base.associatedWithData, {id: fee.associatedWith});
      if (obj) {
        fee.associatedWithName = obj.name;
      }
    });
  }

  formatStrategiesData() {
    const base = this;
    this.template.strategies = this.template.strategies || [];
    _.each(this.template.strategies, (strategy) => {
      const rates = this.allAssociatedData[strategy.strategyId] || [];
      const obj = _.find(rates, {id: strategy.associatedWith});
      if (obj) {
        strategy.associatedWithName = obj.name;
      }
      const strObj = _.find(base.strategiesList, {id: strategy.strategyId});
      if (strObj) {
        strategy.strategyName = strObj.name;
        strategy.strategyType = strObj.type;
        strategy.locked = strObj.locked;
      }
    });
  }

  switchPage(view){
    this.currentView = view;
    jQuery('#a-rates').attr('aria-selected', 'false');
    jQuery('#a-fees').attr('aria-selected', 'false');
    jQuery('#a-strategies').attr('aria-selected', 'false');
    jQuery('#a-' + view).attr('aria-selected', 'true');
  }

}
